// extracted by mini-css-extract-plugin
export default {"SpinningWheel":"SpinningWheel_SpinningWheel__U1yQA","SpinningWheelImage":"SpinningWheel_SpinningWheelImage__JhcHq","SpinningWheelText":"SpinningWheel_SpinningWheelText__f5xMW"};